import { useEffect, useState } from "react";
import { Loader2 } from "lucide-react";
import { appsApi, errMsg, fmtDate } from "@/lib/appsApi";

export const AccessLog = ({ params, show = "user", testid }) => {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    appsApi.get("/admin/access", { params })
      .then((r) => setRows(Array.isArray(r?.data) ? r.data : []))
      .catch((err) => setError(errMsg(err, "Loading access history")));
  }, [params.file_id, params.user_id]); // eslint-disable-line react-hooks/exhaustive-deps

  if (error) return <p className="mt-3 rounded-xl bg-red-50 p-3 text-xs text-red-800" role="alert">{error}</p>;
  if (!rows) return <Loader2 className="mt-3 h-4 w-4 animate-spin text-sky-600" />;
  return (
    <div className="mt-3 rounded-2xl bg-[#F4F9FD] p-3" data-testid={testid}>
      {rows.length === 0 && <p className="text-xs text-slate-600">No downloads yet.</p>}
      <ul className="max-h-56 space-y-1.5 overflow-y-auto">
        {rows.map((r, i) => (
          <li key={`${r.at}-${i}`} className="flex flex-wrap justify-between gap-x-3 text-xs">
            <span className="break-all font-medium text-ink">
              {show === "user" ? (r.name ? `${r.name} · ${r.email}` : r.email) : `v${r.version || "—"} · ${r.file_type || ""}`}
            </span>
            <span className="font-mono text-slate-500">{fmtDate(r.at)}</span>
          </li>
        ))}
      </ul>
    </div>
  );
};
